import en from './en/en.json'
import ka from './ka/ka.json'

export const languages = {
    en: {
        translation: en
    },
    ka: {
        translation: ka
    },
};
